import React, { FunctionComponent, ReactElement, MouseEvent } from 'react'
import Img from 'react-image'
import { imgUrls } from './Carousel'

const style = require('./Carousel.css')

import ChevronIcon from '@uniiverse/library/assets/icons/chevron.svg'
import XIcon from '@uniiverse/library/assets/icons/x.svg'

type DesktopProps = {
  currentImage: number,
  images: Array<imgUrls>,
  renderThumbnails: () => ReactElement<any>,
  onClose: () => void,
  prevImage: (e: MouseEvent) => void,
  nextImage: (e: MouseEvent) => void
}

type MobileProps = {
  currentImage: number,
  images: Array<imgUrls>,
  onClose: () => void,
  prevImage: (e: MouseEvent) => void,
  nextImage: (e: MouseEvent) => void
}

const Preloader = () => {
  return <div className={style['loading-spinner']} />
}

const noOp = (event: MouseEvent) => {
  event.stopPropagation()
}

const DesktopCarouselComponent: FunctionComponent<DesktopProps> = ({
  currentImage,
  images,
  renderThumbnails,
  onClose,
  prevImage,
  nextImage
}) => {
  return (
    <div className={style.carousel} onClick={onClose}>
      <div className={style.carousel__left}>
        <button
          type="button"
          className={[style['carousel__chevron--button'], style['carousel__chevron--left']].join(' ')}
          aria-label="Previous"
          onClick={prevImage}
        >
          <ChevronIcon className={style.icon} />
        </button>
      </div>

      <div className={style.carousel__center}>
        <div className={style.carousel__image}>
          <Img
            src={images[currentImage].fullUrl.replace("1350", window.innerWidth.toString())}
            onClick={noOp}
            loader={Preloader()}/>
        </div>

        <div className={style.carousel__thumbnails}>
          {renderThumbnails()}
        </div>
      </div>

      <div className={style.carousel__right}>
        <button
          type="button"
          className={[style['carousel__chevron--button'], style['carousel__chevron--right']].join(' ')}
          aria-label="Next"
          onClick={nextImage}
        >
          <ChevronIcon className={style.icon} />
        </button>

        <button
          type="button"
          className={style['carousel__close--button']}
          aria-label="Close"
          onClick={onClose}
        >
          <XIcon className={style.icon} />
        </button>
      </div>
    </div>
  )
}

const MobileCarouselComponent: FunctionComponent<MobileProps> = ({
  currentImage,
  images,
  onClose,
  prevImage,
  nextImage
}) => {
  return (
    <div className={style.carousel} onClick={onClose}>
      <div className={style['carousel--mobile']}>
        <div className={style['carousel__close--mobile']} onClick={onClose}>
          <XIcon />
        </div>

        <div className={style['carousel__image__container--mobile']}>
          <img className={style['carousel__image--mobile']} onClick={noOp} src={images[currentImage].fullUrl} />
        </div>

        <div className={style['carousel__navigation__left--mobile']} onClick={prevImage}>
          <ChevronIcon />
        </div>

        <div className={style['carousel__navigation__right--mobile']} onClick={nextImage}>
          <ChevronIcon />
        </div>
      </div>
    </div>
  )
}

export const MobileCarousel = MobileCarouselComponent
export const DesktopCarousel = DesktopCarouselComponent
